import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerInitialState, basedDataReducer } from 'redux/base-reducer';

import { IEecsCertificateModal, IGoCertificate } from '../types/eecs-certificates.type';

interface GoCertificateInitialState extends BaseDataReducerInitialState<IGoCertificate> {
  currentModal: IEecsCertificateModal | null;
  selectedCertificate: IGoCertificate | null;
}

const { initialState, AC, reducer, thunks } = basedDataReducer<IGoCertificate, GoCertificateInitialState>(
  'necs-go-certificate',
);

const goCertificateInitialState: GoCertificateInitialState = {
  ...initialState,
  perPage: 25,
  currentModal: null,
  selectedCertificate: null,
};

export const eecsGoCertificate = createSlice({
  name: 'eecsGoCertificate',
  initialState: goCertificateInitialState,
  reducers: {
    setCertificateModal: (state, action: PayloadAction<IEecsCertificateModal | null>) => {
      state.currentModal = action.payload;
    },
    setSelectedCertificate: (state, action: PayloadAction<IGoCertificate | null>) => {
      state.selectedCertificate = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as GoCertificateInitialState, action);
    });
  },
});

export const GoCertificateAC = AC;
export const onGoCertificateSort = thunks.onSort;
export const onGoCertificateFilter = thunks.onFilter;
export const setGoCertificateCurrentPage = AC.setCurrentPage;

export const { setCertificateModal, setSelectedCertificate } = eecsGoCertificate.actions;
